import React from 'react'
import type { HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLTableSectionElement>

const TBody: React.FC<Props> = ({ children, ...rest }: Props) => (
  <tbody {...rest} className={`tbody`}>
    {children}
  </tbody>
)

export default TBody
